import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import { hideModal } from '../actions/modalsActions'

export type Callback<T = void> = (...args: any) => T

// Report configuration from environment variables
const ANALYTICS_REPORTS = [
  {
    name: 'Opportunity',
    baseUrl: process.env.REACT_APP_ANALYTICS_REPORT_URL,
    paramsTemplate: process.env.REACT_APP_ANALYTICS_REPORT_PARAMS,
  },
]

export interface Props {
  hideModal: Callback
  userEmail: string | null
}

export interface State {
  selectedReport: string
}

export class AnalyticsModalView extends Component<Props, State> {
  static displayName = 'AnalyticsModal'

  state: State = {
    selectedReport: ANALYTICS_REPORTS[0]?.name || '',
  }

  handleReportChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedReport: event.target.value })
  }

  buildReportUrl = (): string => {
    const { userEmail } = this.props
    const { selectedReport } = this.state

    const report = ANALYTICS_REPORTS.find((r) => r.name === selectedReport)
    if (!report) return ''

    const email = userEmail || ''
    const params = report.paramsTemplate?.replace(/{USER_EMAIL}/g, encodeURIComponent(email))

    return `${report.baseUrl}${params}`
  }

  handleViewAnalytics = () => {
    const url = this.buildReportUrl()
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  render() {
    const { hideModal } = this.props
    const { selectedReport } = this.state

    return (
      <Modal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={true}
        onRequestClose={hideModal}
        overlayClassName="analytics-modal__overlay"
        className="analytics-modal__content"
      >
        <div className="analytics-modal">
          <h2 className="analytics-modal__header">Analytics</h2>

          <div className="analytics-modal__dropdown-section">
            <label
              htmlFor="analytics-report-select"
              className="analytics-modal__label"
            >
              Show Analytics
            </label>
            <div className="analytics-modal__select-wrapper">
              <select
                id="analytics-report-select"
                value={selectedReport}
                onChange={this.handleReportChange}
                className="analytics-modal__select"
              >
                {ANALYTICS_REPORTS.map((report) => (
                  <option key={report.name} value={report.name}>
                    {report.name}
                  </option>
                ))}
              </select>
              <div className="analytics-modal__select-arrow">
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1.5L6 6.5L11 1.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="analytics-modal__button-wrapper">
            <button
              type="button"
              onClick={this.handleViewAnalytics}
              className="analytics-modal__button"
            >
              View Analytics
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userEmail: state.session?.user?.email || null,
  }
}

const mapDispatchToProps = {
  hideModal,
}

export const AnalyticsModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticsModalView)
